<template>
  <div>
    <comments></comments>
  </div>
</template>

<script setup lang="ts">
import Comments from '@/components/comments/v2/Comments.vue'

defineOptions({
  name: 'Comments',
})
</script>
